import tyreselector from './tyreselector-4';
import tyreselectorLicense from './tyreselector-4-license';
import tyreselectorModel from './tyreselector-4-model';
import tyreselectorSize from './tyreselector-4-size';

export default {
  init() {
    tyreselector.init();
    tyreselectorLicense.init();
    tyreselectorSize.init();
    tyreselectorModel.init();
  }
}
